import React from 'react'
import "./modal.scss"
import { useNavigate } from 'react-router-dom'


function ModalContainerSmall({title,navigation, children, style }) {

    let navigate = useNavigate()

    return (

        <div className="modal fade show bg-black bg-opacity-70" style={style}>
            <div className="modal-dialog modal-dialog-small modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">

                    {/* header */}
                    <div className="modal-header">
                        <div className="myacc_tab_sec">
                            <button type="button" data-toggle="tooltip" data-html="true"
                                title="Press Space button to close the popup window" className="btn-close popup-close"
                                data-bs-dismiss="modal"
                                onClick={()=>navigate(navigation,{replace:true})}
                                ><img src="/images/close_btn.png"
                                    className="popupclose_icon modal_close" /></button>
                            <ul className="myacc_tab_nav nav" role="tablist">
                                <li className="nav-item">
                                    <p className="nav-link">
                                        {title}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* body */}
                    <div className="modal-body">
                        {children}
                    </div>

                </div>

            </div>



        </div>
    )
}

export default ModalContainerSmall